export default {
    isSidebarOpen: false,
    isNotificationsOpen: false,
    isSearchOpen: false,
    isCreatingJob: false,
    isCreatingChannel: false,
    channels: [],
    currentChannelId: null,
    currentUserChannels: [],
    screenWidth: null
}
